import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CTA_LINKS } from '../../../Data/data.service';

@Component({
  selector: 'app-business-hero',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './business-hero.html',
  styleUrl: './business-hero.css',
})
export class BusinessHeroComponent {
  readonly ctaLinks = CTA_LINKS;

  bookMeeting(): void {
    window.open(this.ctaLinks.meeting.url, this.ctaLinks.meeting.target);
  }
}
